var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"direct-tag"},[_c('img',{staticClass:"icon",attrs:{"src":"/img/tag.direct.svg?pod"}}),(_vm.explained)?_c('span',[_vm._v(_vm._s(_vm.POD_DIRECT_EXPLANATION))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }